import { defineComponent as d, ref as t, computed as a, openBlock as n, createElementBlock as i, normalizeClass as l, renderSlot as s } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const m = [
  // Layout
  "layout-inline-row justify-center",
  // Spacing
  "-mb-[1px]",
  "px-0",
  "py-[6px]",
  // Interactivity
  "interactivity-click",
  // Typography
  "typography-body-2-bold",
  // Theme
  "theme-foreground-secondary",
  "dark:theme-foreground-secondary-dark",
  "theme-border-transparent border-b-2",
  "dark:theme-border-transparent-dark",
  // Theme (hover)
  "hover:md:theme-foreground-default",
  "dark:hover:md:theme-foreground-default-dark",
  // Theme (active)
  "active:theme-foreground-default",
  "dark:active:theme-foreground-default-dark",
  "active:theme-border-current active:border-b-2",
  "dark:active:theme-border-current-dark",
  // Theme (selected)
  "selected:theme-foreground-default",
  "dark:selected:theme-foreground-default-dark",
  "selected:theme-border-current selected:border-b-2",
  "dark:selected:theme-border-current-dark",
  // Theme (invalid)
  "invalid:theme-foreground-error",
  "dark:invalid:theme-foreground-error-dark",
  // Theme (invalid + hover)
  "hover:invalid:md:theme-foreground-error-hover",
  "dark:hover:invalid:md:theme-foreground-error-hover-dark",
  // Theme (invalid + active)
  "active:invalid:theme-foreground-error",
  "dark:active:invalid:theme-foreground-error-dark",
  "active:invalid:theme-border-current active:invalid:border-b-2",
  "dark:active:invalid:theme-border-current-dark"
], f = d({
  name: "OrTab",
  props: {
    selected: {
      type: Boolean,
      default: !1
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "focus",
    "blur"
  ],
  expose: [
    "root"
  ],
  setup() {
    const e = t(), r = a(() => [
      "or-tab-v3",
      ...m
    ]);
    return {
      root: e,
      rootStyles: r
    };
  }
}), c = ["selected", "invalid", "disabled"];
function v(e, r, b, k, p, h) {
  return n(), i("div", {
    ref: "root",
    class: l(e.rootStyles),
    selected: e.selected,
    invalid: e.invalid,
    disabled: e.disabled,
    onClick: r[0] || (r[0] = (o) => e.$emit("click", o)),
    onFocus: r[1] || (r[1] = (o) => e.$emit("focus", o)),
    onBlur: r[2] || (r[2] = (o) => e.$emit("blur", o))
  }, [
    s(e.$slots, "default")
  ], 42, c);
}
const $ = /* @__PURE__ */ u(f, [["render", v]]);
export {
  $ as O
};
//# sourceMappingURL=OrTab-Cl_ZBFjH.mjs.map
